const Exterior = [
    {
        title: "532 Packard",
        narative: "The view of 532 Packard from the street.",
        exteriorImage: "https://s3.amazonaws.com/532packard/picExt1.jpg"
    },
    {
        title: "Front Porch",
        narative: "The view of the building and the front porch",
        exteriorImage: "https://s3.amazonaws.com/532packard/frontporch.jpg"
    },
    {
        title: "View from the front sidewalk",
        narative: "This is the view of the building from the sidewalk",
        exteriorImage: "https://s3.amazonaws.com/532packard/frontwalk.jpg"
    },
    {
        title: "Backyard view from first floor apartment",
        narative: "The backyard has many plants and animals native to Michigan.",
        exteriorImage: "https://s3.amazonaws.com/532packard/backyard.jpg"
    }
]

export default Exterior;




// WEBPACK FOOTER //
// ./src/helpers/exteriorTour.js